<template>
  <div>
    <div v-for="i in numPages" :key="i">
      <pdf :src="pdfSrc" :page="i"></pdf>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js' // 加载中文的包
export default {
  name: 'CustomPdfViewer',
  components: { pdf },
  props: {
    url: {
      type: String,
      default: ''
    },
    isBoolean: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'url': function(newVal, oldVal) {
      this.updatePsfInfo(newVal)
    }
  },
  data() {
    return {
      numPages: [],
      pdfSrc: undefined
    }
  },
  mounted() {
    this.updatePsfInfo(this.url)
  },
  methods: {
    updatePsfInfo(url) {
      if (url) {
        this.pdfSrc = pdf.createLoadingTask({
          url: this.updateHeaderHttps(url),
          CMapReaderFactory
        })
        // 让所有页数一次性加载完，否则就只会加载第一页
        this.pdfSrc.promise.then(pdf => {
          this.numPages = pdf.numPages
          this.$nextTick(() => this.$emit('updateSettlement', { pageNum: this.numPages }))
        }).catch(reason => {
          console.error('reason', reason)
          if (this.isBoolean) {
            this.$message.error('请稍后重试')
            setTimeout(() => {
              window.location.reload()
            }, 500)
          }
        })
      } else {
        this.pdfSrc = undefined
        this.numPages = []
      }
    },
    updateHeaderHttps(pathUrl) {
      if (pathUrl.indexOf('https') < 0) {
        pathUrl = pathUrl.replace('http:', 'https:')
      }
      return pathUrl
    }
  }
}
</script>
<style scoped>
</style>